<template>
  <div
    v-if="show"
    class="context-menu"
    :style="{ top: position.y + 'px', left: position.x + 'px' }"
  >
    <button class="menu-item" @click="handleCopy">
      <AppIcon
        class="icon"
        name="copy-text"
        size="body-xl"
        class-name="color-lighter"
      />
      <span class="menu-item-text">{{
        $t('legal_assistant.actions.copy')
      }}</span>
    </button>

    <button class="menu-item" @click="handleInsert">
      <AppIcon
        class="icon"
        name="insert-text"
        size="body-xl"
        class-name="color-lighter"
      />
      <span class="menu-item-text">{{
        $t('legal_assistant.actions.insert')
      }}</span>
    </button>
  </div>
</template>

<script setup lang="ts">
import AppIcon from '@/components/common/app-icon/AppIcon.vue';
import { PropType } from 'vue';

const props = defineProps({
  show: Boolean,
  position: {
    type: Object as PropType<{ x: number; y: number }>,
    required: true
  },
  text: String
});

const emit = defineEmits(['copy', 'insert']);

const handleCopy = () => {
  emit('copy', props.text);
};

const handleInsert = () => {
  emit('insert', props.text);
};
</script>

<style scoped lang="scss">
.context-menu {
  position: absolute;
  background: $color-neutral-0;
  border-radius: $radius-3;
  box-shadow: $floating-card-shadow;
  overflow: hidden;
  border: 1px solid $color-neutral-100;
}

.menu-item {
  display: flex;
  align-items: center;
  padding: $space-3 $space-4;
  color: $color-text-dark;
  background: none;
  border: none;
  width: 100%;
  text-align: center;
  cursor: pointer;
}

.menu-item-text {
  font-family: $font-family;
  margin-left: $space-3;
}

.menu-item:hover {
  background: $color-neutral-100;
  .icon {
    color: $color-icon-dark;
  }
}
</style>
